import { useState, useRef } from "react";
import { Box, Button as ThemeUIButton } from "theme-ui";

import { useTranslation } from "hooks";
import ModalCenter from "../ModalCenter";
import * as styles from "./ModalVideo.styles";
import { VideoPlayIcon, VideoPauseIcon } from "components/icons";

export default function ModalVideo({ isTopMostModal, onClose, video }) {
  const { t } = useTranslation();

  const { autoPlay = false } = video || {};
  const [videoIsPlaying, setVideoIsPlaying] = useState(autoPlay);

  const videoRef = useRef();

  const onPlayClick = () => {
    setVideoIsPlaying(true);
    videoRef.current.play();
  };

  const onPauseClick = () => {
    setVideoIsPlaying(false);
    videoRef.current.pause();
  };

  const onVideoEnded = () => {
    setVideoIsPlaying(false);
  };

  return (
    <ModalCenter
      onClose={onClose}
      isTopMostModal={isTopMostModal}
      maxWidthOverride={"440px"}
    >
      <Box sx={styles.modalVideoContainer}>
        <video
          ref={videoRef}
          onEnded={onVideoEnded}
          width="440px"
          height="640px"
          muted
          loop
          autoPlay={autoPlay}
        >
          <source src={video.url} type="video/mp4" />
          {t("Your browser does not support the video tag.")}
        </video>
        {videoIsPlaying ? (
          <ThemeUIButton
            onClick={onPauseClick}
            variant="unstyled"
            sx={styles.videoPauseButton}
            id="modal-video-play-button"
          >
            <VideoPauseIcon />
          </ThemeUIButton>
        ) : (
          <ThemeUIButton
            onClick={onPlayClick}
            variant="unstyled"
            sx={styles.videoPlayButton}
          >
            <VideoPlayIcon />
          </ThemeUIButton>
        )}
      </Box>
    </ModalCenter>
  );
}
